import { render, staticRenderFns } from "./Latestupload.vue?vue&type=template&id=6379c041&scoped=true&"
import script from "./Latestupload.vue?vue&type=script&lang=js&"
export * from "./Latestupload.vue?vue&type=script&lang=js&"
import style0 from "./Latestupload.vue?vue&type=style&index=0&id=6379c041&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6379c041",
  null
  
)

export default component.exports